import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { func, bool, string, shape } from "prop-types";
import { selectors as settingsSelectors, actions as settingsActions } from "reducers/settings";
import PhoneInput from "pages/_components/fields/PhoneInput";
import Credential from "pages/_components/fields/credentials/Credential";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import Notification from "pages/_components/Notification";
import { actions, selectors } from "reducers/softToken";

const FORM_ID = "settings.changePhone";
class ChangePhone extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        fetching: bool.isRequired,
        mobilePhone: string,
        deviceStatus: string.isRequired,
        tokenInfo: shape({}).isRequired,
    };

    static defaultProps = {
        mobilePhone: "",
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(settingsActions.getUserData());
        dispatch(actions.getTokenInfo());
    }

    handleSubmit = ({ mobilePhone, otp = "" }, formikBag) => {
        const { dispatch, deviceStatus, tokenInfo } = this.props;
        const token = deviceStatus === "NO_DEVICE" ? otp : tokenInfo.token;
        dispatch(settingsActions.sendMobilePhoneCode(mobilePhone, token, formikBag));
    };

    handleFormSubmit = (event, { handleSubmit, errors }) => {
        const canSubmit = Object.values(errors).every((error) => error === undefined);
        if (canSubmit) {
            handleSubmit(event);
        } else {
            event.preventDefault();
        }
    };

    renderForm = ({ isSubmitting, ...form }) => {
        const { isDesktop, fetching, mobilePhone, deviceStatus } = this.props;
        return (
            <form className="above-the-fold" onSubmit={(event) => this.handleFormSubmit(event, form)}>
                <Container className="container--layout flex-grow items-center" gridClassName="form-content">
                    <Container.Column xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                        <p className="text-lead">
                            <I18n id="settings.changePhone.explanation" />
                        </p>
                        <Field
                            component={PhoneInput}
                            idForm={FORM_ID}
                            name="mobilePhone"
                            isDesktop={isDesktop}
                            mobilePhone={mobilePhone}
                        />
                    </Container.Column>
                </Container>
                {deviceStatus !== "NO_DEVICE" ? null : (
                    <Container className="container--layout" gridClassName="form-content">
                        <Container.Column xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                            <hr />
                            <h4>
                                <I18n id="settings.changePhone.verifyWithCredential" />
                            </h4>
                            <Field idForm={FORM_ID} name="otp" component={Credential} type="otp" />
                        </Container.Column>
                    </Container>
                )}
                <Container className="container--layout" gridClassName="form-content">
                    <Container.Column xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                        <Button
                            type="submit"
                            bsStyle="primary"
                            label="global.modify"
                            loading={isSubmitting}
                            disabled={fetching}
                            block
                        />
                    </Container.Column>
                </Container>
            </form>
        );
    };

    render() {
        const { mobilePhone, fetching } = this.props;
        return (
            <Fragment>
                <Head title="settings.changePhone" closeLinkTo="/settings" />
                <Notification scopeToShow="changePhone" />
                <MainContainer showLoader={fetching}>
                    <Formik
                        initialValues={{ mobilePhone, otp: "" }}
                        onSubmit={this.handleSubmit}
                        validateOnChange={false}
                        // validationSchema={}
                        enableReinitialize>
                        {this.renderForm}
                    </Formik>
                </MainContainer>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    mobilePhone: settingsSelectors.getMobilePhone(state),
    fetching: settingsSelectors.isFetching(state),
    tokenInfo: selectors.getTokenInfo(state),
    deviceStatus: selectors.getDeviceStatus(state),
});

export default connect(mapStateToProps)(ChangePhone);
